__webpack_require__.p = "https://assets.worldcubeassociation.org/assets/f5b2d14/packs/";